module.exports = __webpack_public_path__ + "pc/img/main-magazine-img-03.39dca1e3.jpg";